import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { IEventDirectoryFirestoreDoc } from "modules/eventDirectory/types";

interface Props {
  showTimerPanel: boolean;
  eventDirectories: IEventDirectoryFirestoreDoc[] | null;
}

export const useStyles = makeStyles<Theme, Props>((theme) => ({
  appBar: {
    backgroundColor: "transparent",
    boxShadow: "none",
    marginTop: theme.spacing(0.5),
    gridArea: "appBar",
  },
  topBar: {
    pointerEvents: "all",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.default,
    position: "fixed",
    border: `1px solid ${theme.palette.border.default}`,
    top: ({ showTimerPanel }: Props) => (showTimerPanel ? "29px" : "2px"),
    left: "4px",
    right: "4px",
    borderRadius: "4px",
    minHeight: "55px",
    zIndex: 2,

    [theme.breakpoints.down("lg")]: {
      top: "0px",
      left: "0px",
      right: "0px",
      borderRadius: "0px",
    },
  },
  timerClearence: {
    top: "30px !important",
  },
  logoContainer: {
    height: "55px",
    width: "unset",
    borderRight: `1px solid ${theme.palette.border.default}`,
    [theme.breakpoints.down("md")]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      margin: theme.spacing(1),
    },
  },
  logo: {
    margin: `0px ${theme.spacing(1)}`,
    [theme.breakpoints.down("md")]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      margin: "0px",
      marginRight: theme.spacing(1),
    },
  },
  mapBanner: {
    pointerEvents: "all",
    [theme.breakpoints.down("md")]: {
      width: ({ eventDirectories }: Props) => (eventDirectories ? 90 : "auto"),
    },
  },
  profileMenu: {
    pointerEvents: "all",
    marginRight: theme.spacing(0.5),
  },
  mapNavigation: {
    pointerEvents: "all",
    gridArea: "mapNavigation",
    zIndex: 100,
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "unset",
    },
  },
  editEventButton: {
    color: theme.palette.text.primary,
    width: theme.spacing(5.5),
    height: theme.spacing(5.5),
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: theme.spacing(0.5),
    },
  },
}));
